import React, {useContext} from 'react'
import MultiSelectSearch from "./MultiSelectSearch"
import SelectSearch from "./SelectSearch"
import {SettingLayoutContext} from "../../context/SettingLayoutContext"

const LayoutFilter = props => {
    const {filters, onChangeFilter} = props
    const SettingLayoutPageContext = useContext(SettingLayoutContext)
    const {
        tenant,
        listLayoutType,
        listLayoutBlock,
        listLayoutField,
        listFieldType
    } = SettingLayoutPageContext

    return (
        <div className="CallHistoryFilters Filters mb-3">
            <div className="itemFilter mb-3">
                <SelectSearch
                    listSelect={tenant}
                    name='tenantId'
                    value={filters.tenantId}
                    label="Tenant"
                    onChange={onChangeFilter}
                />
            </div>
            <div className="itemFilter mb-3">
                <MultiSelectSearch
                    listSelect={listLayoutType}
                    name='layoutType'
                    value={filters.layoutType}
                    label="Loại layout"
                    onChange={onChangeFilter}
                />
            </div>
            <div className="itemFilter mb-3">
                <MultiSelectSearch
                    listSelect={listLayoutBlock}
                    name='layoutBlock'
                    value={filters.layoutBlock}
                    label="Block"
                    onChange={onChangeFilter}
                />
            </div>
            <div className="itemFilter mb-3">
                <MultiSelectSearch
                    listSelect={listLayoutField}
                    name='layoutField'
                    value={filters.layoutField}
                    label="Thông tin"
                    onChange={onChangeFilter}
                />
            </div>
            <div className="itemFilter mb-3">
                <MultiSelectSearch
                    listSelect={listFieldType}
                    name='fieldType'
                    value={filters.fieldType}
                    label="Kiểu dữ liệu"
                    onChange={onChangeFilter}
                />
            </div>
        </div>
    )
}

LayoutFilter.propTypes = {}

export default LayoutFilter